// var ACCOUNT = {
// 	addListeners: function() {
// 		console.log("Account Pagelisteners have been added");
// 		$('.account__edit').click(function(event) {
// 			if($(this).hasClass('name')){
// 				ACCOUNT.showNameEditForm();
// 			} else if ($(this).hasClass('email')) {
// 				ACCOUNT.showEmailEditForm()
// 			}	
// 		});
// 		$('#save__name').click(function(event) {
// 			var nameForm = $(this).closest('form');
// 			ACCOUNT.submitName(nameForm);
// 		});	
// 	},
// 	onLoad: function() {
// 		$("#account__tabs").tabs()
// 	},
// 	showNameEditForm: function(){
// 		console.log("Showing Account Name Edit Form");
// 		$('.name__edit--wrapper').removeClass('hidden').show();
// 		$('.name__display--wrapper').addClass('hidden').hide();
// 	},
// 	showEmailEditForm: function(){
// 		console.log("Showing Account Email Edit Form");
// 	},
// 	submitName: function(form) {
// 		var url = form.attr('action');
// 		var customerID = parseInt($('#customer-id__edit').attr('data-customer-id'));
// 		var firstName = $('#first-name__edit').val();
// 		var lastName = $('#last-name__edit').val();
// 		var data = {
// 								"customer": {
// 									"id": customerID,
// 									"first_name": firstName, 
// 									"last_name": lastName 
// 								}
// 							}	
// 		$.ajax({
// 			url: url,
// 			type: 'PUT',
// 			data: data
// 		})
// 		.success(function(data) {
// 			console.log(data);
// 		})
// 	}
// }		
// $(document).ready( function(){
// 	ACCOUNT.onLoad();
// 	ACCOUNT.addListeners();
// });



var ACCOUNT = {
	addListeners: function() {
		console.log("Account Pagelisteners have been added");

		$('#create_customer').on('submit', function(){
			ga('send', 'event', 'Create New Account', 'Sign Up', 'Accounts');
		});

		$('a[href="#returnModal"]').click(function(event) {
			event.preventDefault();
			console.log("return modal triggered");
			var orderNum = $(this).attr('data-order-num');
			var customerName = $(this).attr('data-customer-name');
			var customerEmail = $(this).attr('data-customer-email');
			ACCOUNT.renderReturnModal(orderNum, customerName, customerEmail);
		});

		$('#returnSubmit').click(function(event) {
			event.preventDefault();
			var orderNum = $('#returnOrderNum').text();
			var customerName = $('#returnName').text();
			var customerEmail = $('#returnEmail').text();
			var message = $('#returnMessage').val();
			ACCOUNT.sendReturnNotice(orderNum, customerName, customerEmail, message);
		});
	},
	onLoad: function() {
		$("#account__tabs").tabs();
		if ( $('#address_form_new').length > 0 ){
			console.log("main height adjustment")
			// debugger;
		  var main = $('main')
	    var detailsHeight = $('#details').height();
	    var formHeight = $('#address_form_new').height();
	    var newHeight = formHeight + detailsHeight  + 700 ;
	    $(main).css('minHeight', newHeight );
		}

	},
	renderReturnModal: function(orderNum, customerName, customerEmail){
		$('#returnModal').fadeIn("200");
		$('body').addClass('stop-scrolling');		
		var nameElement = $('#returnName');
		var emailElement = $('#returnEmail');
		var orderNumberElement = $('#returnOrderNum');
		var messageElement = $('#returnMessage');
		nameElement.empty().text(customerName);
		emailElement.empty().text(customerEmail);
		orderNumberElement.empty().text(orderNum);
	},
	sendReturnNotice: function(orderNum, customerName, customerEmail, message){
		var data = 		{
								    "key": "qmIyjTAvJOgKWGiNuXtEwg",
								    "message": {
								    		"html":"<h2>This return was initiated via chase54.com. Please follow up with the customer to complete the return.<h3>Order Number: "+orderNum+"</h3><h3>Customer Name: "+customerName+"</h3><h3>Customer Email: "+customerEmail+"</h3><h3>Message: <h3><p>"+message+"</p>",
								        "subject": "New Return",
								        "from_email": "inf@chase54.com",
								        "from_name": "CHASE54.com",
								        "to": [
								            {
								                "email": "customerservice@chase54.com",
								                "name": "Chase54 Customer Service",
								                "type": "to"
								            }
								        ],
								        "headers": {
								            "Reply-To": "customerservice@chase54.com"
								        },
								        "merge": false
								    },
								    "async": false
									}
		console.log(data)							
		$.ajax({
			url: 'https://mandrillapp.com/api/1.0/messages/send.json',
			data: data,
		})
		.done(function(data) {
			console.log("success");
			ACCOUNT.returnNoticeSuccessMessage(customerEmail);
		})
		.fail(function(data) {
			console.log("error");
		})
	},
	returnNoticeSuccessMessage: function(customerEmail){
		$('#returnMessage').val('');
		$('form#returnForm').prepend('<p class="returnSuccess body-text"><i class="fa fa-check" aria-hidden="true"></i> Your Return has been initated. You will receive an email with further instructions at '+customerEmail+'.</p>');
		$('form#returnForm').find('input[type="submit"]').attr('disabled', 'disabled').addClass('disabled');
		setTimeout( function( ) { HOME_PAGE.closeModals() }, 4500);
		setTimeout( function( ) { 
			$('form#returnForm').find('input[type="submit"]').removeAttr('disabled').removeClass('disabled');
			$('.returnSuccess').remove();
		}, 4500);
	}
}		
$(function(){
	ACCOUNT.onLoad();
	ACCOUNT.addListeners();
});



// var orderNum = $(this).attr('data-order-num');
// ACCOUNT.sendReturnNotice(orderNum, customerName, customerEmail, message)